<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('measure_edit.title') }}</h1>
      <measure-form :id="id" :colony="colony" :apiary="apiary"></measure-form>
    </b-container>
  </div>
</template>

<script>
import MeasureForm from '../components/MeasureForm'
export default {
  name: 'MeasureEdit',
  components: { MeasureForm },
  props: ['id', 'colony', 'apiary']
}
</script>

<style scoped>

</style>
